<template>
  <div class="carousel">
    <el-carousel height="600px">
      <el-carousel-item v-for="(item, index) in carousel" :key="index">
        <a v-if="item.url" :href="item.url" :target="getTarget(item.url)">
          <div class="carousel-container" v-if="item.file"
          :style="{ 'background-image': 'url(' + (($mq.resize && $mq.above('769px')) ? item.file.path : (item.file_mobile ? item.file_mobile.path : item.file.path)) + ')' }" />
        </a>
        <div class="carousel-container" v-else-if="item.file"
        :style="{ 'background-image': 'url(' + (($mq.resize && $mq.above('769px')) ? item.file.path : (item.file_mobile ? item.file_mobile.path : item.file.path)) + ')' }" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import Site from '@/api/site'
export default {
  name: 'Carousel',
  data () {
    return {
      carousel: [
        {
          file: {
            path: '/static/carousel.jpg'
          }
        }
      ]
    }
  },
  mounted () {
    this.onLoad()
  },
  methods: {
    onLoad () {
      Site.getCarousel().then((res) => {
        if (res.result.length > 0) {
          this.carousel = res.result
          console.log('res.result', res.result)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    getTarget (url) {
      return url.includes(window.location.hostname) ? '_self' : '_blank'
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../styles/settings.scss";
.carousel {
  overflow: hidden;
}
.carousel-container {
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
}
</style>



// WEBPACK FOOTER //
// src/components/Carousel.vue